/**
 * `s731` — ВРЕМЯ ЗВОНКА МЕНЕДЖЕР НАЗЫВАЕТ ПО МОСКВЕ, А НЕ ПО ЧАСАМ СВОЕГО КОМПЬЮТЕРА.
 *
 * Авария 08.10.2026: менеджер выбрала «Перезвонить» на 15:00, а лид показал 11:00 и «просрочено».
 * Её компьютер стоял в поясе Саратова (UTC+4): окно читало введённое время «по часам этого
 * компьютера», 15:00 уходило на сервер как 11:00 UTC — это 14:00 по Москве, на час раньше задуманного.
 * (Вторая половина той же аварии — сервер писал в лид время UTC как московское, минус ещё три часа.)
 * Все филиалы работают по Москве, поэтому поле времени — московские часы на любом компьютере.
 * Летнего времени в Москве нет: смещение постоянное, +03:00.
 */
const MSK_MIN = 180;

/** Момент → значение поля `datetime-local` по московским часам. */
export function mskDlyaPolya(d: Date): string {
  return new Date(d.getTime() + MSK_MIN * 60_000).toISOString().slice(0, 16);
}

/** Значение поля `datetime-local` (московские часы) → момент; пустое или кривое — `null`. */
export function mskIzPolya(znachenie: string): Date | null {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(znachenie)) return null;
  const d = new Date(`${znachenie.slice(0, 16)}:00+03:00`);

  return Number.isNaN(d.getTime()) ? null : d;
}

/** Момент словами по московским часам: «08.10.2026 в 15:00». */
export function mskSlovami(d: Date): string {
  const [data, vremya] = mskDlyaPolya(d).split('T');
  const [god, mesyac, den] = data.split('-');

  return `${den}.${mesyac}.${god} в ${vremya}`;
}

/** Ровный час по Москве: сегодня (`dney = 0`) или через `dney` дней, в `chas`:00. */
export function mskVChas(osnova: Date, dney: number, chas: number): Date {
  const [god, mesyac, den] = mskDlyaPolya(osnova).slice(0, 10).split('-').map(Number);

  return new Date(Date.UTC(god, mesyac - 1, den + dney, chas, 0, 0) - MSK_MIN * 60_000);
}

/** Ближайший ровный час по Москве не раньше чем через час — заготовка для поля. */
export function mskCherezChasRovno(osnova: Date): Date {
  const d = new Date(osnova.getTime() + 3_600_000);
  d.setUTCMinutes(0, 0, 0);

  return d;
}

/**
 * ⛔ `s1027` G-15: «СЕГОДНЯ» И «ЭТОТ МЕСЯЦ» — ПО МОСКВЕ, А НЕ ПО ЧАСАМ КОМПЬЮТЕРА.
 * Календарь, неделя журнала и зарплата брали число у браузера: на компьютере в
 * другом поясе (или с полуночи до трёх по Москве при поясе UTC) «сегодня»
 * подсвечивалось не тем днём, а месяц по умолчанию — не тем месяцем.
 */
export function mskSegodnya(osnova: Date = new Date()): string {
  return mskDlyaPolya(osnova).slice(0, 10);
}

/** Текущий месяц по Москве: `YYYY-MM`. */
export function mskMesyac(osnova: Date = new Date()): string {
  return mskDlyaPolya(osnova).slice(0, 7);
}
